import React from 'react';
import { withRouter } from 'react-router-dom';

class VisualizarCentro extends React.Component {

    constructor() {

        super();

        this.state = {
            id: "",
            nome: "",
            banco: "",
            agencia: "",
            contaBanco: "",
            saldoInicial: "",
            saldoAtual: "",
            saldoInicialInvestimento: "",
            saldoInvestimento: "",
            bancoSec: "",
            agenciaSec: "",
            contaBancoSec: "",
            saldoInicialSec: "",
            saldoAtualSec: "",
            saldoInicialInvestimentoSec: "",
            saldoInvestimentoSec: "",
            ativo: ""
        };

        this.editar = this.editar.bind(this);
        this.voltar = this.voltar.bind(this);

    }

    moneyMask(str_val) {

        let res = "";
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    estaAtivo(ativo) {
        if (ativo) return "Ativo";
        else return "Inativo";
    }

    editar() {

        let obj = {
            id: this.state.id,
            nome: this.state.nome,
            banco: this.state.banco,
            agencia: this.state.agencia,
            contaBanco: this.state.contaBanco,
            saldoInicial: this.state.saldoInicial,
            saldoAtual: this.state.saldoAtual,
            saldoInicialInvestimento: this.state.saldoInicialInvestimento,
            saldoInvestimento: this.state.saldoInvestimento,
            bancoSec: this.state.bancoSec,
            agenciaSec: this.state.agenciaSec,
            contaBancoSec: this.state.contaBancoSec,
            saldoInicialSec: this.state.saldoInicialSec,
            saldoAtualSec: this.state.saldoAtualSec,
            saldoInicialInvestimentoSec: this.state.saldoInicialInvestimentoSec,
            saldoInvestimentoSec: this.state.saldoInvestimentoSec,
            ativo: this.state.ativo
        };

        this.props.history.push({
            pathname: "/editarcentro",
            state: obj
        });

    }

    voltar() {
        this.props.history.push("/centros");
    }

    componentDidMount() {

        if (localStorage.roleCentros === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/centros";
        }

        let centroId = this.props.location.state.row.id;
        this.setState({ id: centroId });

        fetch("/api/centro/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ nome: responseJson.nome });
            this.setState({ banco: responseJson.banco });
            this.setState({ agencia: responseJson.agencia });
            this.setState({ contaBanco: responseJson.conta_banco });
            this.setState({ saldoInicial: responseJson.saldo_inicial });
            this.setState({ saldoAtual: responseJson.saldo_atual });
            this.setState({ saldoInicialInvestimento: responseJson.saldo_inicial_investimento });
            this.setState({ saldoInvestimento: responseJson.saldo_investimento });
            this.setState({ bancoSec: responseJson.banco_sec });
            this.setState({ agenciaSec: responseJson.agencia_sec });
            this.setState({ contaBancoSec: responseJson.conta_banco_sec });
            this.setState({ saldoInicialSec: responseJson.saldo_inicial_sec });
            this.setState({ saldoAtualSec: responseJson.saldo_atual_sec });
            this.setState({ saldoInicialInvestimentoSec: responseJson.saldo_inicial_investimento_sec });
            this.setState({ saldoInvestimentoSec: responseJson.saldo_investimento_sec });
            this.setState({ ativo: responseJson.ativo });

        });

    }

    render() {
        return(
            <div>
                <h1 id="visualizar-centro-titulo">Centro de Custo</h1><br /><br />
                <table id="visualizar-centro-table">
                    <tbody>
                        <tr>
                            <td><b>Nome:</b></td>
                            <td>{ this.state.nome }</td>
                        </tr>
                        <tr>
                            <td><b>Banco:</b></td>
                            <td>{ this.state.banco }</td>
                        </tr>
                        <tr>
                            <td><b>Agência:</b></td>
                            <td>{ this.state.agencia }</td>
                        </tr>
                        <tr>
                            <td><b>Conta Bancária:</b></td>
                            <td>{ this.state.contaBanco }</td>
                        </tr>
                        <tr>
                            <td><b>Saldo Inicial:</b></td>
                            <td>{ "R$ " + this.formatarValor(this.state.saldoInicial) }</td>
                        </tr>
                        <tr>
                            <td><b>Saldo Atual:</b></td>
                            <td>{ "R$ " + this.formatarValor(this.state.saldoAtual) }</td>
                        </tr>
                        <tr>
                            <td><b>Saldo Inicial de Investimento:</b></td>
                            <td>{ "R$ " + this.formatarValor(this.state.saldoInvestimento) }</td>
                        </tr>
                        <tr>
                            <td><b>Saldo de Investimento:</b></td>
                            <td>{ "R$ " + this.formatarValor(this.state.saldoInvestimento) }</td>
                        </tr>
                        <tr>
                            <td><b>Banco Secundário:</b></td>
                            <td>{ this.state.bancoSec }</td>
                        </tr>
                        <tr>
                            <td><b>Agência Secundária:</b></td>
                            <td>{ this.state.agenciaSec }</td>
                        </tr>
                        <tr>
                            <td><b>Conta Bancária Secundária:</b></td>
                            <td>{ this.state.contaBancoSec }</td>
                        </tr>
                        <tr>
                            <td><b>Saldo Inicial Secundário:</b></td>
                            <td>
                                { this.state.saldoInicialSec !== null && "R$ " }
                                { this.formatarValor(this.state.saldoInicialSec) }
                            </td>
                        </tr>
                        <tr>
                            <td><b>Saldo Atual Secundário:</b></td>
                            <td>
                                { this.state.saldoAtualSec !== null && "R$ " }
                                { this.formatarValor(this.state.saldoAtualSec) }
                            </td>
                        </tr>
                        <tr>
                            <td><b>Saldo Inicial de Investimento Secundário:</b></td>
                            <td>
                                { this.state.saldoInvestimentoSec !== null && "R$ " }
                                { this.formatarValor(this.state.saldoInvestimentoSec) }
                            </td>
                        </tr>
                        <tr>
                            <td><b>Saldo de Investimento Secundário:</b></td>
                            <td>
                                { this.state.saldoInvestimentoSec !== null && "R$ " }
                                { this.formatarValor(this.state.saldoInvestimentoSec) }
                            </td>
                        </tr>
                        <tr>
                            <td><b>Status:</b></td>
                            <td>{ this.estaAtivo(this.state.ativo) }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                { localStorage.roleCentros === "escrever" &&
                    <button id="visualizar-centro-btn" onClick={ this.editar }>
                        Editar
                    </button> }
                <button id="visualizar-centro-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarCentro);

